import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-8 py-6">
      <div className="max-w-[1600px] mx-auto flex items-center justify-between">
        {/* Logo */}
        <Link to="/" aria-label="going plus — Home" className="flex items-center hover:opacity-80 transition-opacity">
          <img
            src="/logo-transparent.png"
            alt="going plus"
            width="44"
            height="44"
            className="h-10 w-auto md:h-11"
            loading="eager"
            decoding="async"
          />
          <span className="sr-only">going plus</span>
        </Link>

        {/* Navigation Links */}
        <div className="flex items-center gap-8">
          <Link 
            to="/work" 
            className="text-white text-sm lowercase tracking-wide hover:opacity-70 transition-opacity"
          >
            work
          </Link>
          <Link 
            to="/us" 
            className="text-white text-sm lowercase tracking-wide hover:opacity-70 transition-opacity"
          >
            us
          </Link>
          
          {/* LinkedIn Icon Only */}
          <a 
            href="https://www.linkedin.com/in/taiga-kunii-9a153280/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white hover:opacity-70 transition-opacity ml-4"
          >
            <Linkedin size={18} />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;